import {
  ARCHIVE_INSURANCE_CARD,
  ARCHIVE_INSURANCE_CARD_ERROR,
  ARCHIVE_INSURANCE_CARD_SUCCESS,
  DELETE_INSURANCE_CARD,
  DELETE_INSURANCE_CARD_ERROR,
  DELETE_INSURANCE_CARD_SUCCESS,
  DELETE_PATIENT,
  DELETE_PATIENT_ERROR,
  DELETE_PATIENT_SUCCESS,
  LOAD_APPOINTMENTS,
  LOAD_APPOINTMENTS_ERROR,
  LOAD_APPOINTMENTS_SUCCESS,
  LOAD_EVENT_MESSAGES,
  LOAD_EVENT_MESSAGES_ERROR,
  LOAD_EVENT_MESSAGES_SUCCESS,
  LOAD_FILES,
  LOAD_FILES_ERROR,
  LOAD_FILES_SUCCESS,
  LOAD_OFFERS,
  LOAD_OFFERS_ERROR,
  LOAD_OFFERS_SUCCESS,
  LOAD_PATIENT,
  LOAD_PATIENT_ERROR,
  LOAD_PATIENT_SUCCESS,
  LOAD_PATIENT_JOURNEY,
  LOAD_PATIENT_JOURNEY_ERROR,
  LOAD_PATIENT_JOURNEY_SUCCESS,
  LOAD_WAITLISTS,
  LOAD_WAITLISTS_ERROR,
  LOAD_WAITLISTS_SUCCESS,
  RESET_FILES_REDUCER,
  RESTORE_INSURANCE_CARD,
  RESTORE_INSURANCE_CARD_ERROR,
  RESTORE_INSURANCE_CARD_SUCCESS,
  SAVE_PATIENT,
  SAVE_PATIENT_ERROR,
  SAVE_PATIENT_SUCCESS,
  RESET_PATIENT_DATA,
  GET_PATIENT_AUDIT,
  GET_PATIENT_AUDIT_ERROR,
  GET_PATIENT_AUDIT_SUCCESS,
} from './constants';

export const archiveInsuranceCard = (insuranceCard) => ({
  type: ARCHIVE_INSURANCE_CARD,
  loading: true,
  insuranceCard,
});

export const archiveInsuranceCardError = (error) => ({
  type: ARCHIVE_INSURANCE_CARD_ERROR,
  error,
});

export const archiveInsuranceCardSuccess = (notification) => ({
  type: ARCHIVE_INSURANCE_CARD_SUCCESS,
  notification,
});

export const deleteInsuranceCard = (insuranceCard) => ({
  type: DELETE_INSURANCE_CARD,
  loading: true,
  insuranceCard,
});

export const deleteInsuranceCardError = (error) => ({
  type: DELETE_INSURANCE_CARD_ERROR,
  error,
});

export const deleteInsuranceCardSuccess = (notification) => ({
  type: DELETE_INSURANCE_CARD_SUCCESS,
  notification,
});

export const deletePatient = (patient) => ({
  type: DELETE_PATIENT,
  loading: true,
  patient,
});

export const deletePatientError = (error) => ({
  type: DELETE_PATIENT_ERROR,
  error,
});

export const deletePatientSuccess = () => ({ type: DELETE_PATIENT_SUCCESS });

export const loadAppointments = (id) => ({
  type: LOAD_APPOINTMENTS,
  loading: true,
  id,
});

export const loadAppointmentsError = (error) => ({
  type: LOAD_APPOINTMENTS_ERROR,
  error,
});

export const loadAppointmentsSuccess = (appointments) => ({
  type: LOAD_APPOINTMENTS_SUCCESS,
  appointments,
});

export const loadEventMessages = (filters) => ({
  type: LOAD_EVENT_MESSAGES,
  filters,
  loading: true,
});

export const loadEventMessagesError = (error) => ({
  type: LOAD_EVENT_MESSAGES_ERROR,
  error,
});

export const loadEventMessagesSuccess = (response) => ({
  type: LOAD_EVENT_MESSAGES_SUCCESS,
  response,
});

export const loadFiles = (patientId) => ({
  type: LOAD_FILES,
  loading: true,
  patientId,
});

export const loadFilesError = (error) => ({
  type: LOAD_FILES_ERROR,
  error,
});

export const loadFilesSuccess = (files) => ({
  type: LOAD_FILES_SUCCESS,
  files,
});

export const loadOffers = (id) => ({
  type: LOAD_OFFERS,
  loading: true,
  id,
});

export const loadOffersError = (error) => ({
  type: LOAD_OFFERS_ERROR,
  error,
});

export const loadOffersSuccess = (offers) => ({
  type: LOAD_OFFERS_SUCCESS,
  offers,
});

export const loadPatient = (id) => ({
  type: LOAD_PATIENT,
  id,
});

export const loadPatientError = (error) => ({
  type: LOAD_PATIENT_ERROR,
  error,
});

export const loadPatientSuccess = (patient) => ({
  type: LOAD_PATIENT_SUCCESS,
  patient,
});

export const loadPatientJourney = (id, rangeBy, includeDetails) => ({
  type: LOAD_PATIENT_JOURNEY,
  loading: true,
  id,
  rangeBy,
  includeDetails,
});

export const loadPatientJourneyError = (error) => ({
  type: LOAD_PATIENT_JOURNEY_ERROR,
  error,
});

export const loadPatientJourneySuccess = (response) => ({
  type: LOAD_PATIENT_JOURNEY_SUCCESS,
  response,
});

export const loadWaitlists = (id) => ({
  type: LOAD_WAITLISTS,
  loading: true,
  id,
});

export const loadWaitlistsError = (error) => ({
  type: LOAD_WAITLISTS_ERROR,
  error,
});

export const loadWaitlistsSuccess = (waitlists) => ({
  type: LOAD_WAITLISTS_SUCCESS,
  waitlists,
});

export const resetFilesReducer = () => ({
  type: RESET_FILES_REDUCER,
});

export const restoreInsuranceCard = (insuranceCard) => ({
  type: RESTORE_INSURANCE_CARD,
  loading: true,
  insuranceCard,
});

export const restoreInsuranceCardError = (error) => ({
  type: RESTORE_INSURANCE_CARD_ERROR,
  error,
});

export const restoreInsuranceCardSuccess = (notification) => ({
  type: RESTORE_INSURANCE_CARD_SUCCESS,
  notification,
});

export const savePatient = (patient) => ({
  type: SAVE_PATIENT,
  patient,
});

export const savePatientError = (error) => ({
  type: SAVE_PATIENT_ERROR,
  error,
});

export const savePatientSuccess = (data, notification) => ({
  type: SAVE_PATIENT_SUCCESS,
  data,
  notification,
});

export const resetPatientData = () => ({
  type: RESET_PATIENT_DATA,
});

export const getPatientAudit = (patientId) => ({
  type: GET_PATIENT_AUDIT,
  patientId,
});

export const getPatientAuditError = (error) => ({
  type: GET_PATIENT_AUDIT_ERROR,
  error,
});

export const getPatientAuditSuccess = (data) => ({
  type: GET_PATIENT_AUDIT_SUCCESS,
  data,
});
